import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalVariable } from 'app/main/globals';
import { keys } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class AspCartService {

  constructor(
    private http: HttpClient,
  ) { }

  getUserDetails(garageKey){    
    
    // console.log('-----Get User Details-----------');    
    return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}` + '/garage/address/getAll/'+garageKey);
  }

  getShippingCharges(cartGrandTotal, garageKey){
    let keys = [];
    if(localStorage.getItem('addedCart')){ 
      let cartData;
      cartData = JSON.parse(localStorage.getItem('addedCart'));
      Object.keys(cartData[0]).forEach(partKeys => { 
        keys.push(partKeys);
      });
    }
    
    let paramData = {      
      cartValue: cartGrandTotal,
      partKeys: keys,
      garageKey: garageKey,
      source: "web" 
      // addressId: addressId,
    };

    // console.log(paramData);

    // console.log('-----Get Shipping charges-----------');    
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/order/getShippingCharges', paramData);
  }
  getMegaSavings(garageKey,partNumber,rowKey,variantKey){
let paramData = {      
      garageKey: garageKey,
      partNumber: partNumber,
      rowKey: rowKey,
      variantKey:variantKey 
      // addressId: addressId,
    };
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/spare/getAlternateParts', paramData);

  }
// getCartData(cartKey: string) {
//   const isLocalhost = window.location.hostname === 'localhost';
//   const baseUrl = isLocalhost
//     ? 'http://localhost:8099'
//     : GlobalVariable.BASE_API_URL_SPARES;

//   // return this.http.get(`${baseUrl}/cart/get/${garageKey}/${cartKey}/${userKey}`);
//   return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}/cart/get/${cartKey}`);

// }
// getCartData(cartKey: string, requestId?: string) {
//   const isLocalhost = window.location.hostname === 'localhost';
//   const baseUrl = isLocalhost
//     ? 'http://localhost:8099'
//     : GlobalVariable.BASE_API_URL_SPARES;

//   const url = requestId
//     ? `${baseUrl}/cart/get/${cartKey}/${requestId}`
//     : `${baseUrl}/cart/get/${cartKey}`;
//    console.log('GET API URL:', url);
//   return this.http.get(url);
// }
getCartData(cartKey: string, requestId?: string) {
  const isLocalhost = window.location.hostname === 'localhost';
  const baseUrl = isLocalhost
    ? 'http://localhost:8099'
    : GlobalVariable.BASE_API_URL_SPARES;

  const url = `${baseUrl}/cart/get/${cartKey}/${requestId || 'null'}`;

  console.log('GET API URL:', url);
  return this.http.get(url);
}


createCart(payload: any[]) {
  return this.http.post<any>(`${GlobalVariable.BASE_API_URL_SPARES}/cart/create`, payload);
}
updateCartDetails(payload: { cartKey: string }) {
  return this.http.post<any>(
    `${GlobalVariable.BASE_API_URL_SPARES}/cart/update/cartDetails`,
    payload
  );
}

}
